import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  TypographyProps,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { getSubmissionState } from '../../../../store/SubmissionSlice';
import { IQuestion } from '../../../../store/QuestionSlice';
import { useAppSelector } from '../../../../hooks';
import BasicLoader from '../../../../components/Loaders/BasicLoader';
import { TP_COLORS } from '../../../../constants';
import MarkdownRenderer from '../../../../helper/MarkdownRenderer/MarkdownRenderer';

export interface IShowAiHintModal {
  open: boolean;
  onClose: () => void;
  question: IQuestion;
}

const aiTypoProps: TypographyProps = {
  fontWeight: '600',
  mr: '5px',
  sx: {
    background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
};

const ShowAiHintModal: React.FC<IShowAiHintModal> = ({
  open,
  onClose,
  question,
}) => {
  // HOOKS
  const submissionState = useAppSelector(getSubmissionState);

  // RENDER
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          minWidth: { xs: '90vw', sm: '400px' },
          maxWidth: '500px',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          padding: '2px',
          borderRadius: '20px',
          background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
        }}
      >
        <Box
          sx={{
            borderRadius: '20px',
            background: TP_COLORS.white,
            padding: '10px',
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/backgrounds/graphic2.png)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <DialogContent>
            {submissionState.status === 'loading' ? (
              <Box component="div" role="presentation">
                <BasicLoader />
              </Box>
            ) : (
              <Box component="div" role="presentation">
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '20px',
                  }}
                >
                  <Typography fontSize="22px" component="span" {...aiTypoProps}>
                    Hint
                  </Typography>
                  <span style={{ fontSize: '20px' }}>💡</span>
                </Box>
                {question && question.aiHint ? (
                  <MarkdownRenderer content={question.aiHint || ''} />
                ) : null}
                <IconButton
                  onClick={onClose}
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
          </DialogContent>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ShowAiHintModal;
